import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Programs from "@/pages/Programs";
import Coaching from "@/pages/Coaching";
import Freebie from "@/pages/Freebie";
import Newsletter from "@/pages/Newsletter";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/coaching" element={<Coaching />} />
            <Route path="/freebie" element={<Freebie />} />
            <Route path="/newsletter" element={<Newsletter />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Legal kind="privacy" />} />
            <Route path="/terms" element={<Legal kind="terms" />} />
            <Route path="/disclaimer" element={<Legal kind="disclaimer" />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </Layout>
        <Toaster position="top-center" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
